import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import routingStartsWith from "../../../common/helpers/routingStartsWith";

import logout from "../../store/user/actions/logout";
import { useUser } from "../../store/user/selectors";
import routing from "../../routing";

import Login from "../Login";

import NavLeft from "./NavLeft";
import NavRight from "./NavRight";
import NavMobile from "./NavMobile";

import { StyledNav, NavSpring } from "./styles";
import { IProps } from "./interfaces";

const Nav = ({ darkMode, setDarkMode }: IProps) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const resize = useCallback(() => {
        if (window.innerWidth > 768 && mobileMenuOpen) {
            setMobileMenuOpen(false);
        }
    }, [setMobileMenuOpen, mobileMenuOpen]);

    useEffect(() => {
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        }
    }, []);
    
    const handleLogout = async () => {
        dispatch(logout());
        history.push("/");
    }

    const handleNavigate = () => {
        setMobileMenuOpen(old => !old);
    };

    const { pathname } = history.location;
    const user = useUser();
    let props = {
        loggedIn: user.loggedIn,
        pathname,
        admin: user.permission >= 2,
        profiled: user.profiled,
        user,
        darkMode,
        setDarkMode,
    };
    let auth = {
        logout: handleLogout,
    };
    let isPathBrowse =
        routingStartsWith(pathname, routing.browse) || routingStartsWith(pathname, routing.publicPlan) ? 1 : 0;
    let isPathHomeworks =
        routingStartsWith(pathname, routing.classes) ||
        routingStartsWith(pathname, routing.homeworkResult)
            ? 1
            : 0;
    let isPathHomework =
        routingStartsWith(pathname, routing.homework) || routingStartsWith(pathname, routing.homeworkCompleted)
            ? 1
            : 0;
    let isPathDashboard =
        routingStartsWith(pathname, routing.dashboard) ||
        routingStartsWith(pathname, routing.pack) ||
        routingStartsWith(pathname, routing.plan)
            ? 1
            : 0;
    let isPathHomeworksActive =
        routingStartsWith(pathname, routing.classes) ? 1 : 0;
    let isPathDashboardActive =
        routingStartsWith(pathname, routing.dashboard) || routingStartsWith(pathname, routing.pack) ? 1 : 0;
    let isPathHelp = routingStartsWith(pathname, routing.help) ? 1 : 0;
    let isModeration =
        routingStartsWith(pathname, routing.moderation) || routingStartsWith(pathname, routing.testModeration)
            ? 1
            : 0;
    let isAccount = routingStartsWith(pathname, routing.account) ? 1 : 0;
    let isSignup = routingStartsWith(pathname, routing.signup) ? 1 : 0;
    let isTranslate = routingStartsWith(pathname, routing.translate) ? 1 : 0;
    let isAboutUs = routingStartsWith(pathname, routing.aboutUs) ? 1 : 0;
    let isLogin = routingStartsWith(pathname, routing.login) ? 1 : 0;
    let isTeachingSettings = routingStartsWith(pathname, routing.teachingSettings) ? 1 : 0;
    let isStudentDashboard = routingStartsWith(pathname, routing.dashboardStudent) || routingStartsWith(pathname, routing.homeworkStudentResults) ? 1 : 0;
    let paths = {
        isPathBrowse,
        isPathDashboard,
        isPathDashboardActive,
        isPathHomeworks,
        isPathHomeworksActive,
        isPathHomework,
        isModeration,
        isAccount,
        isSignup,
        isPathHelp,
        isTranslate,
        isAboutUs,
        isTeachingSettings,
        isStudentDashboard,
        isLogin,
    };
    return (
        <StyledNav>
            <NavSpring>
                <NavLeft
                    {...props}
                    {...auth}
                    {...paths}
                    mobileMenuOpen={mobileMenuOpen}
                    handleOpenMobileMenu={handleNavigate}
                />
                <NavRight
                    {...props}
                    {...auth}
                    {...paths}
                    mobileMenuOpen={mobileMenuOpen}
                    handleOpenMobileMenu={handleNavigate}
                />
                <NavMobile
                    {...props}
                    {...auth}
                    {...paths}
                    mobileMenuOpen={mobileMenuOpen}
                    navigate={handleNavigate}
                />
            </NavSpring>
        </StyledNav>
    );
}

export default Nav;
